import { Stack } from "expo-router";
import Head from "expo-router/head";
import { CallRequestProvider } from "@/contexts/CallRequestContext";

export default function CallRequestLayout() {
  return (
    <CallRequestProvider>
      <Head>
        <title>RockForce Call Request</title>
        <meta name="description" content="Submit a call/staffing request to RockForce" />
      </Head>
      <Stack screenOptions={{ headerShown: false }}>
        <Stack.Screen name="welcome-back" />
        <Stack.Screen name="(wizard)" />
      </Stack>
    </CallRequestProvider>
  );
}
